import { getPublicData } from "../../../../../services/publicPegasApi/MakePublicOrder";


export default async function PrintDailyReport(printData = {}, invoiceDataOrOptions = {}, orderId, options = {}) {
  // invoiceDataOrOptions may be invoiceData (legacy) OR options object passed from printDailyShiftUtils (contains totals)
  let publicData = {};
  try {
    publicData = await getPublicData();
    console.log("📞 بيانات الشركة المسترجعة:", publicData);
  } catch (err) {
    console.error("❌ فشل في جلب البيانات العامة:", err);
  }

  // Normalize invoiceData and options, extract totals if provided
  let invoiceData = {};
  let mergedOptions = { ...(options || {}) };
  let providedTotals = {};
  let providedTableHtml = undefined;

  if (invoiceDataOrOptions && typeof invoiceDataOrOptions === "object" && !Array.isArray(invoiceDataOrOptions)) {
    // support call: PrintShiftReports(sessions, { totals, tableHtml, ...otherOptions })
    if ("totals" in invoiceDataOrOptions || "tableHtml" in invoiceDataOrOptions) {
      providedTotals = invoiceDataOrOptions.totals || {};
      providedTableHtml = invoiceDataOrOptions.tableHtml;
      mergedOptions = { ...invoiceDataOrOptions, ...mergedOptions };
      // clean out helper keys from mergedOptions so they don't appear later as unrelated options
      delete mergedOptions.totals;
      delete mergedOptions.tableHtml;
      invoiceData = {};
    } else {
      // legacy: invoiceData passed
      invoiceData = invoiceDataOrOptions || {};
    }
  } else {
    invoiceData = invoiceDataOrOptions || {};
  }

  const logoUrl = publicData?.logo ? publicData.logo.trim().replace(/\s+/g, '') : "";
  console.log("🖼️ رابط اللوجو النهائي:", logoUrl);

  // If an array was passed -> render multi-session report
  if (Array.isArray(printData)) {
    const sessions = printData;
    const title = mergedOptions?.title || "تقرير اليوميات ";

    // compute fallback totals if not provided
    const computedTotals = (function () {
      let withdrawalsExpenses = 0;
      let invoices = 0;
      let deposits = 0;
      (sessions || []).forEach(s => {
        const grouped = s.grouped_transactions_by_shift || {};
        Object.values(grouped).forEach(arr => {
          (arr || []).forEach(tx => {
            const amt = parseFloat(tx.amount) || 0;
            if (tx.type === "withdrawal" || tx.type === "expenses") withdrawalsExpenses += amt;
            if (tx.type === "invoice") invoices += amt;
            if (tx.type === "deposit") deposits += amt;
          });
        });
      });
      const totalNet = invoices + deposits - withdrawalsExpenses;
      return { totalWithdrawalsExpenses: withdrawalsExpenses, totalInvoices: invoices, totalDeposits: deposits, totalNet };
    })();

    const totals = {
      totalWithdrawalsExpenses: providedTotals.totalWithdrawalsExpenses ?? computedTotals.totalWithdrawalsExpenses,
      totalInvoices: providedTotals.totalInvoices ?? computedTotals.totalInvoices,
      totalDeposits: providedTotals.totalDeposits ?? computedTotals.totalDeposits,
      totalNet: providedTotals.totalNet ?? computedTotals.totalNet,
    };

    // if caller provided ready-made table HTML, use it; otherwise build per-session HTML as before
    const rowsHtml = providedTableHtml
      ? providedTableHtml
      : sessions.map((s) => {
        const grouped = s.grouped_transactions_by_shift || {};
        const totalTx = Object.values(grouped).reduce((acc, arr) => acc + (Array.isArray(arr) ? arr.length : 0), 0);
        const shiftsHtml = Object.entries(grouped).map(([shiftName, txs]) => {
          const txRows = (txs || []).map((tx, idx) => `
            <tr>
              <td style="border:1px solid #ddd;padding:6px;text-align:right">${idx + 1}</td>
              <td style="border:1px solid #ddd;padding:6px;text-align:right">${tx.type || "-"}</td>
              <td style="border:1px solid #ddd;padding:6px;text-align:right">${tx.amount ?? "-"}</td>
              <td style="border:1px solid #ddd;padding:6px;text-align:right">${tx.bank?.name || "-"}</td>
              <td style="border:1px solid #ddd;padding:6px;text-align:right">${tx.bank_to?.name || "-"}</td>
              <td style="border:1px solid #ddd;padding:6px;text-align:right">${tx.bank_from?.name || "-"}</td>
              <td style="border:1px solid #ddd;padding:6px;text-align:right">${tx.transaction_date || "-"}</td>
              <td style="border:1px solid #ddd;padding:6px;text-align:right">${(tx.invoice ? (`فاتورة ${tx.invoice.id}`) : "-")}</td>
            </tr>
          `).join("");
          return `
            <div style="margin-top:8px">
              <h4 style="margin:6px 0">الوردية: ${shiftName}</h4>
              <table style="width:100%;border-collapse:collapse;margin-bottom:6px">
                <thead>
                  <tr>
                    <th style="border:1px solid #ddd;padding:6px">م</th>
                    <th style="border:1px solid #ddd;padding:6px">النوع</th>
                    <th style="border:1px solid #ddd;padding:6px">المبلغ</th>
                    <th style="border:1px solid #ddd;padding:6px">الخزنة</th>
                    <th style="border:1px solid #ddd;padding:6px">إلى خزنة</th>
                    <th style="border:1px solid #ddd;padding:6px">من خزنة</th>
                    <th style="border:1px solid #ddd;padding:6px">تاريخ العملية</th>
                    <th style="border:1px solid #ddd;padding:6px">فاتورة</th>
                  </tr>
                </thead>
                <tbody>
                  ${txRows || `<tr><td colspan="8" style="padding:6px;text-align:center">لا توجد عمليات</td></tr>`}
                </tbody>
              </table>
            </div>
          `;
        }).join("");

        return `
          <section style="border-bottom:1px dashed #ccc;padding:12px 0;margin-bottom:12px">
            <h3 style="margin:6px 0">اليومية: ${s.session_id} — ${s.session_date}</h3>
            <p style="margin:4px 0">المستخدم: ${s.user?.name || "-" } (${s.user?.username || "-"})</p>
            <p style="margin:4px 0">عدد العمليات: ${totalTx}</p>
            ${shiftsHtml}
          </section>
        `;
      }).join("");

    // Summary HTML (totals)
    const summaryHtml = `
      <div style="display:flex;gap:12px;flex-wrap:wrap;margin-bottom:16px">
        <div style="padding:10px;border-radius:6px;background:#fff4f4;border:1px solid #f2c2c2;min-width:200px">
          <div style="font-weight:700;color:#b71c1c">المسحوبات + المصروفات</div>
          <div style="font-size:18px">${totals.totalWithdrawalsExpenses.toLocaleString()} ج.م</div>
        </div>
        <div style="padding:10px;border-radius:6px;background:#eaf6ff;border:1px solid #c2e0ff;min-width:200px">
          <div style="font-weight:700;color:#1565c0">إجمالي الفواتير</div>
          <div style="font-size:18px">${totals.totalInvoices.toLocaleString()} ج.م</div>
        </div>
        <div style="padding:10px;border-radius:6px;background:#ecfff3;border:1px solid #cff1dc;min-width:200px">
          <div style="font-weight:700;color:#2e7d32">إيداع إلى الخزنة</div>
          <div style="font-size:18px">${totals.totalDeposits.toLocaleString()} ج.م</div>
        </div>
        <div style="padding:10px;border-radius:6px;background:#fff8e1;border:1px solid #ffe8b0;min-width:200px">
          <div style="font-weight:700;color:#ff8f00">الصافي</div>
          <div style="font-size:18px">${(totals.totalNet || 0).toLocaleString()} ج.م</div>
        </div>
      </div>
    `;

    const html = `<!doctype html>
      <html dir="rtl">
      <head><meta charset="utf-8"><title>${title}</title>
      <style>
        body{font-family:Arial,Helvetica,sans-serif;direction:rtl;padding:20px}
        h1,h2,h3,h4{margin:6px 0}
        table{width:100%;border-collapse:collapse;margin-top:6px}
        th,td{border:1px solid #ddd;padding:6px;text-align:right}
        th{background:#f5f5f5}
      </style>
      </head>
      <body>
        ${logoUrl ? `<div style="text-align:center;margin-bottom:10px"><img src="${logoUrl}" alt="logo" style="max-width:240px;max-height:80px;object-fit:contain" onerror="this.style.display='none'"/></div>` : ""}
        <h1 style="text-align:center">${publicData?.name || "تقرير اليوميات"}</h1>
        ${summaryHtml}
        ${rowsHtml}
      </body>
      </html>
    `;
    return html;
  }

  // otherwise fallback to original single-order printing behavior
  // orderDetails passed as printData, invoiceData param remains invoiceData, orderId as is
  const orderDetails = printData || {};
  const inv = invoiceData || {};
  const items = orderDetails.items || [];

  const subtotal = items.reduce(
    (acc, item) =>
      acc +
      parseFloat(item.price || item.unit_price || (item.total && item.quantity ? item.total / item.quantity : 0) || 0) *
        parseFloat(item.quantity || 0),
    0
  );

  const service = parseFloat(inv.service || 0);
  const tax = parseFloat(inv.tax || 0);
  const discount = parseFloat(inv.discount || 0);
  const total = subtotal + service + tax - discount;

  const footerText = (() => {
    const base = (inv.footer_text || "").trim();
    const note = (publicData?.invoice_note_printer || "").trim();
    const pieces = [];
    if (base) pieces.push(base);
    if (note) pieces.push(note);
    return pieces.join("<br/>");
  })();

  const address = publicData?.address || "";
  const phone = publicData?.phone || "";

  const orderPrintNumber = inv?.order_print_number || 1;

  return `
    <!DOCTYPE html>
    <html dir="rtl">
    <head>
      <meta charset="UTF-8" />
      <style>
        @page { size: 80mm auto; margin: 0; }
        html, body { height: 100%; margin: 0; padding: 0; display: flex; justify-content: center; background: #fff; }
        .receipt { font-family: 'Cairo', sans-serif; width: 80mm; padding: 8px; margin: 0 auto; font-size: 13px; color: #000; direction: rtl; text-align: right; box-sizing: border-box; }
        h2, h3 { margin: 4px 0; text-align: center; }
        hr { border: none; border-top: 1px dashed #000; margin: 6px 0; }
        table { width: 100%; border-collapse: collapse; }
        th, td { padding: 3px 0; text-align: right; }
        th { border-bottom: 1px dashed #000; }
        .footer { text-align: center; margin-top: 10px; font-size: 12px; }
        .logo { width: 220px; height: 220px; object-fit: contain; display: block; margin: 0 auto 20px; transform: translateX(6mm); }
      </style>
    </head>
    <body>
      <div class="receipt">
        ${logoUrl ? `<img src="${logoUrl}" class="logo" alt="Logo" onerror="this.style.display='none'" />` : ""}
        <h2>${inv.header_text || publicData?.name || "تطبيق رستو كاش"}</h2>
        <h3>فاتورة رقم #${orderDetails.general_increment || orderId || "-"}</h3>
        <h3>رقم الفاتورة: ${orderId}</h3>
        <p><strong>عدد مرات الطباعة:</strong> ${orderPrintNumber}</p>
        <hr />
        <p>العميل: ${orderDetails.customer?.name || "بدون اسم"}</p>
        <p>الطاولة: ${orderDetails.table?.name || "غير محددة"}</p>
        <hr />
        <table>
          <thead>
            <tr>
              <th>الصنف</th>
              <th>السعر</th>
              <th>الكمية</th>
              <th>الإجمالي</th>
            </tr>
          </thead>
          <tbody>
            ${items
              .map((item) => {
                const price = parseFloat(item.price || item.unit_price || (item.total && item.quantity ? item.total / item.quantity : 0));
                return `
                  <tr>
                    <td>${item.product_name || "-"}</td>
                    <td>${(isNaN(price) ? 0 : price).toFixed(2)} ج</td>
                    <td>${item.quantity || 0}</td>
                    <td>${(parseFloat(item.total) || 0).toFixed(2)} ج</td>
                  </tr>
                `;
              })
              .join("")}
          </tbody>
        </table>
        <hr />
        <p>الإجمالي الفرعي: ${subtotal.toFixed(2)} ج</p>
        <p>الخدمة: ${service.toFixed(2)} ج</p>
        <p>الضريبة: ${tax.toFixed(2)} ج</p>
        <p>الخصم: ${discount.toFixed(2)} ج</p>
        <hr />
        <h3>الإجمالي الكلي: ${total.toFixed(2)} ج</h3>
        <hr />
        <div class="footer">
          ${footerText ? `<p>${footerText}</p>` : `<p>شكرًا لزيارتكم ❤️</p>`}
          ${address ? `<p>📍 العنوان: ${address}</p>` : ""}
          ${phone ? `<p>📞 الهاتف: ${phone}</p>` : ""}
          <p>تم بواسطة نظام ريستو كاش</p>
        </div>
      </div>
    </body>
    </html>
  `;
}



